/* DermaGlow global.js */
(function () {
  'use strict';

  /* ---------- Drawers ---------- */
  var overlay = document.querySelector('[data-drawer-overlay]');
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) { closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown').replace(' ', 'T'));
    if (isNaN(end)) return;
    var units = {
      d: el.querySelector('[data-cd-days]'),
      h: el.querySelector('[data-cd-hours]'),
      m: el.querySelector('[data-cd-mins]'),
      s: el.querySelector('[data-cd-secs]')
    };
    function tick() {
      var diff = end - new Date();
      if (diff <= 0) { el.closest('[data-countdown-wrap]') && (el.closest('[data-countdown-wrap]').hidden = true); return; }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (units.d) units.d.textContent = String(d).padStart(2, '0');
      if (units.h) units.h.textContent = String(h).padStart(2, '0');
      if (units.m) units.m.textContent = String(m).padStart(2, '0');
      if (units.s) units.s.textContent = String(s).padStart(2, '0');
      setTimeout(tick, 1000);
    }
    tick();
  });

  /* ---------- Hero slider ---------- */
  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var track = slider.querySelector('.hero-slider__track');
    var slides = slider.querySelectorAll('.hero-slide');
    var dots = slider.querySelectorAll('.hero-slider__dot');
    var idx = 0, timer = null;
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(slider.getAttribute('data-speed') || '5', 10) * 1000;
    if (slides.length < 2) return;
    function go(i) {
      idx = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + idx * 100 + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === idx); });
    }
    function restart() { if (!autoplay) return; clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, speed); }
    slider.addEventListener('click', function (e) {
      if (e.target.closest('[data-hero-next]')) { go(idx + 1); restart(); }
      if (e.target.closest('[data-hero-prev]')) { go(idx - 1); restart(); }
      var dot = e.target.closest('[data-hero-dot]');
      if (dot) { go(parseInt(dot.getAttribute('data-hero-dot'), 10)); restart(); }
    });
    restart();
  });

  /* ---------- Tabs ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tab-btn]');
      if (!btn) return;
      var key = btn.getAttribute('data-tab-btn');
      wrap.querySelectorAll('[data-tab-btn]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      wrap.querySelectorAll('[data-tab-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === key);
      });
    });
  });

  /* ---------- Horizontal carousels ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-carousel-track]');
    if (!track) return;
    wrap.addEventListener('click', function (e) {
      var step = track.clientWidth * 0.8;
      if (e.target.closest('[data-carousel-next]')) track.scrollBy({ left: step, behavior: 'smooth' });
      if (e.target.closest('[data-carousel-prev]')) track.scrollBy({ left: -step, behavior: 'smooth' });
    });
  });

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var val = parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-qty-change'), 10);
    input.value = Math.max(parseInt(input.min || '1', 10), val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- AJAX add to cart ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      b.textContent = count;
      b.hidden = count === 0;
    });
  }
  function refreshCartDrawer(openAfter) {
    var body = document.querySelector('[data-cart-drawer-body]');
    var foot = document.querySelector('[data-cart-drawer-footer]');
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
      if (!body) return;
      if (cart.item_count === 0) {
        body.innerHTML = document.getElementById('CartEmptyTemplate') ? document.getElementById('CartEmptyTemplate').innerHTML : '<p class="cart-empty-help">Your cart is empty.</p>';
        if (foot) foot.hidden = true;
      } else {
        var html = '';
        cart.items.forEach(function (item) {
          html += '<div class="cart-drawer-item">' +
            '<img src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '') + '" alt="" loading="lazy" width="72" height="72">' +
            '<div><div class="cart-drawer-item__title">' + item.product_title + '</div>' +
            '<div class="cart-drawer-item__meta">' + (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : '') + 'Qty ' + item.quantity + '</div></div>' +
            '<div class="price">' + formatMoney(item.final_line_price) + '</div></div>';
        });
        body.innerHTML = html;
        if (foot) {
          foot.hidden = false;
          var st = foot.querySelector('[data-cart-subtotal]');
          if (st) st.textContent = formatMoney(cart.items_subtotal_price);
        }
      }
      if (openAfter) openDrawer('CartDrawer');
    });
  }
  function formatMoney(cents) {
    var fmt = (window.themeSettings && window.themeSettings.moneyFormat) || 'Rs. {{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.orig = btn.textContent; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { refreshCartDrawer(window.themeSettings ? window.themeSettings.cartDrawer : true); })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.orig; } });
  });
  document.addEventListener('DOMContentLoaded', function () { refreshCartDrawer(false); });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gallery-thumb]');
      if (!t || !main) return;
      main.src = t.getAttribute('data-src');
      main.srcset = '';
      g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
    });
  });

  /* ---------- Variant picker (updates price + id) ---------- */
  document.querySelectorAll('[data-product-form-wrap]').forEach(function (wrap) {
    var dataEl = wrap.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = wrap.querySelector('input[name="id"]');
    var priceEl = wrap.querySelector('[data-price-current]');
    var compareEl = wrap.querySelector('[data-price-compare]');
    var addBtn = wrap.querySelector('[data-add-btn]');
    wrap.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-input]')) return;
      var selected = [];
      wrap.querySelectorAll('.variant-fieldset').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked) selected.push(checked.value);
      });
      var match = variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (addBtn.getAttribute('data-add-label') || 'Add to cart') : (addBtn.getAttribute('data-soldout-label') || 'Sold out');
      }
    });
  });
})();
